<!-- eslint-disable vue/no-unused-vars -->
<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="container-fluid">
    <Breadcrumbs main="Battery Intensities" :path="breadcrumbPath" />
    <el-row class="m-0 width-100-p mt-3">
      <el-col class="d-flex align-item-center px-2" :span="24">
        <div class="row m-0 width-100-p px-2">
          <div
            class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
          >

            <el-row :gutter="$vuetify.display.width > 1200 ? 20 : 0">
              <!-- search bay -->
              <el-col
                    :span="$vuetify.display.width > 1200 ? 16 : 24"
                    :class="$vuetify.display.width > 1200 ? 'x-start order-1 mb-10' : 'x-start order-3 mb-10'"
                  >
                    <el-input
                      size="large"
                      v-model="search"
                        :placeholder="'Type to search by charging site name or emission intensity'"
                        :prefix-icon="Search"
                        class="mixedSearchBar-2"
                        id="mixedSearchBar-input-2"
                        clearable
                        @clear="handleReload"
                    >                      
                      <template #append>
                        <!-- <el-button :icon="Search" /> -->
                        <el-button
                            @click.stop="handleReload"
                            class="newSearchButtonClass"
                          >
                          <svg v-if="$vuetify.display.width > 800" class="width-115 height-40">
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon"
                            ></use>
                          </svg>
                          <svg v-else class="width-59 height-40" >
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon-small"
                            ></use>
                          </svg>
                        </el-button>
                      </template>
                    </el-input>

              </el-col>

              <!-- export button -->
              <el-col
                    :class="$vuetify.display.width > 1200 ? 'd-flex justify-content-end order-2' : 'd-flex justify-content-end order-1 mb-20'"
                    :span="$vuetify.display.width > 1200 ? 8 : 24"
                  >
                  <el-button
                      v-if="
                          $store.state.auth.user != null &&
                          !$store.state.auth.user.is_auditor
                        "
                      @click.stop="handleNew"
                      class="newAddButtonNoText new-button-behavior x-end"
                      size="small"
                    >
                        <svg class="width-40 height-40">
                          <use href="@/assets/svg/newSvgIcon.svg#newAddButtonNoText"></use>
                        </svg>
                    </el-button>
                    <el-button
                      @click.stop="handleExportFile"
                      class="new-download-file-btn new-button-behavior x-end"
                    >
                        <svg class="width-40 height-40">
                          <use href="@/assets/svg/newSvgIcon.svg#newDownloadFileIcon"></use>
                        </svg>
                    </el-button>
              </el-col>
            </el-row>

            <DataTable
              :loadingProp="loading"
              :usersDataProp="displayTableData"
              :totalRowProp="total_items"
              :monitoringPeriodsProp="monitoringPeriods"
              @tableAction="handleTableAction"
            />
          </div>
        </div>
      </el-col>
    </el-row>
    <ShowDetail
      :open_modal="show_modal"
      :data_modal="data_modal"
      :monitoringPeriodsProp="monitoringPeriods"
      :copiedDataProp="copiedData"
      @close_modal="close_modal"
      @confirm_modal="confirm_modal"
      @refreshDataTable="handleRefresh"
    />


  </div>
</template>

<script>
import Breadcrumbs from "../../components/bread_crumbs.vue";
// import XLSX from "xlsx";
import { exportToExcel } from "../dashboard/common/exportExcel";
import UserService from "../../services/user.service";
import DataTable from "./dataTable.vue";
import ShowDetail from "./dialogDetail.vue";
import { ElMessageBox } from "element-plus";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "battery-intensities",
  components: {
    Breadcrumbs,
    // Filter,
    ShowDetail,
    DataTable,
  },
  data() {
    return {
      breadcrumbPath: [
        {
          title: "Input",
          disabled: true,
          href: "",
        },
        {
          title: "Battery Intensities",
          disabled: false,
          href: "/battery-intensities",
          active: true,
        },
      ],

      show: true,

      // pagination and search
      battery_intensityDataList: [],
      beforeSearch: [],
      monitoringPeriods: [],
      searchResult: [],
      displayTableData:[],
      search: "",
      current_page: 0,
      page_size: 50,
      total_items: 100,
      perPageCount: 50,


      loading: false,
      show_modal: false,
      data_modal: null,
      current_row_index: null,
      filterOpen: false,
      copiedData: null, // data copied from data table
    };
  },
  watch: {
    // pagination and search
    battery_intensityDataList: {
      handler: "applySearch",
      immediate: true,
    },

    searchResult: {
      handler: "handlePaginatedData",
      immediate: true,
    },

    current_page: {
      handler: "handlePaginatedData",
      immediate: true,
    },

    page_size: {
      handler: "handlePaginatedData",
      immediate: true,
    },
    // pagination and search

  },
  computed: {
    filter_battery_intensities() {
      return this.battery_intensityDataList;
    },

    // pagination for table data
    paginatedData() {
      let start = (this.current_page - 1 ) * this.page_size;
      let end = (start + this.page_size) >= this.searchResult.length ? (this.searchResult.length) : (start + this.page_size);
      let data = this.searchResult;
      return data.slice(start, end);
    },
    
  },
  mounted() {
    this.fetchBatteryIntensitiesData(1);
    this.fetchMonitoringPeriodData();
    this.copiedData = null; // reset copied data
  },
  methods: {

    // update chart series data with paginated data
    handlePaginatedData() {
      this.displayTableData = this.paginatedData;
      // this.loadingBarChart = false;
    },

    fetchBatteryIntensitiesData(page) {
      UserService.getBatteryIntensities(
        null,
        this.search,
        page,
        this.perPageCount,
        true // bypass pagination
      )
        .then(
          (response) => {
            this.battery_intensityDataList = response.data.battery_intensities;
            this.beforeSearch = response.data.battery_intensities;
            this.total_items = response.data.total_record;
          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        ).then(
          () => {
            this.current_page = 1;
            this.page_size = 50;
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    // eslint-disable-next-line no-unused-vars
    handleRowClick(row, column, event) {
      // console.log(row, column, event);
    },
    // eslint-disable-next-line no-unused-vars
    close_modal(event) {
      this.show_modal = false;
    },

    confirm_modal(event) {
      if (this.battery_intensityDataList.length == this.current_row_index) {
          this.battery_intensityDataList.push(event);
          this.total_items += 1;
        }
      else this.battery_intensityDataList[this.current_row_index] = event;
      this.show_modal = false;
    },

    handleShow(index, data) {
      this.current_row_index = index;
      this.data_modal = JSON.stringify(data);
      this.show_modal = true;
    },

    async handleExportFile() {
      if (this.filter_battery_intensities.length > 0) {

        const dataList = this.filter_battery_intensities.map((row) => {
          const mapped = {};
          Object.keys(row).forEach((key) => {
            if (key === "monitoring_period_id") {
              const mp = this.monitoringPeriods.find(
                (period) => period.id == row.monitoring_period_id
              );
              mapped.monitoring_period =
                mp == null ? "" : mp.name == null ? mp.status_display : mp.name;
            } else {
              mapped[key] = row[key];
            }
          });
          return mapped;
        });
        const skipKeys = ["customer_id", "charging_site_id", "id"]; // Keys to skip
        const fileName = "BatteryIntensitiesList.xlsx"; // File name
        const newWorksheetName = "Battery Intensities List"; // Worksheet name
        const title = "Battery Intensities List"; // Title for the Excel file

        try {

        
        await exportToExcel({
          dataList,
          skipKeys,
          fileName,
          newWorksheetName,
          title,
        });
      } catch(error) {
        console.log("error when export excel", error.message);
        
      }
      } else {
        console.log("empty data list");
      }
    },

    async fetchMonitoringPeriodData() {
      // Start: Try from sessionStorage first
      const cached = sessionStorage.getItem("monitoringPeriods");
      if (cached) {
          try {
            const parsed = JSON.parse(cached);
            this.monitoringPeriods = parsed;
            return;
          } catch (err) {
            console.error("Error parsing sessionStorage monitoringPeriods");
            console.log("no monitoring periods in session data, fetching monitoring periods...");
          }
      }
      else {
        const response = await UserService.getMonitoringPeriods(null, "", 1, 50, true);
        const data = response.data.monitoring_periods || [];
        if (data.length > 0) {
          sessionStorage.setItem("monitoringPeriods", JSON.stringify(data));
          this.monitoringPeriods = data;
        } else {
          // no data in MP database, set selected mp name to '12 months'
          console.log('Monitoring periods data is empty');
          return;
        }
      }
    },

    // handleExportFile() {
    //   if (this.filter_battery_intensities.length > 0) {
    //     const myHeader = [
    //       "charging_site_title",
    //       "emission_intensity",
    //       "updated_at",
    //     ];
    //     const ws = XLSX.utils.json_to_sheet(this.filter_battery_intensities, {
    //       header: myHeader,
    //     });
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, "Data");
    //     XLSX.writeFileXLSX(wb, "BatteryIntensitiesList.xlsx");
    //   }
    // },

    reset_filter(event) {
      this.current_page = 1;
      this.search = "";
      this.filter = event.filter;
    },

    handleTableAction(event) {
      if (event.kind == "edit") {
        this.handleShow(event.index, event.data);
      } else if (event.kind == "delete") {
        this.deleteRow(event.data, event.index);
      } else if (event.kind == "changePage") {
        console.log("change page", event);
        this.current_page = event.index;
        // this.fetchBatteryIntensitiesData(this.current_page);
      } else if (event.kind == "copy") {
        this.handleCopyRow(event.data, event.index);
      } else if (event.kind == "perPageChange") {
        console.log("perPageChange", event);
        this.current_page = 1;
        this.page_size = event.index;
        this.perPageCount = event.index;
        this.handleReload();
      }
    },

    handleCopyRow(event) {
      // console.log(event, index);
      this.copiedData = event;
    },

    handleRefresh() {
      this.fetchBatteryIntensitiesData(this.current_page);
    },

    applySearch(){
      let search = this.search;
      console.log("call search", search);

      if (search != "") {
        const term = search.toString().toLowerCase().trim();
        this.searchResult = [];
        let Result = this.beforeSearch.filter((item) => 
          item.charging_site_title?.toLowerCase().includes(term) ||
          item.emission_intensity?.toString().toLowerCase().includes(term)
        );

        this.searchResult = Result;
        this.total_items = Result.length;
        
      } else {
        let Result = this.beforeSearch;
        this.searchResult = Result;
        this.total_items = Result.length;
      }
      
    },

    handleReload() {
      // this.fetchBatteryIntensitiesData(this.current_page);
      this.current_page = 1;
      this.applySearch(this.search);
    },
    handleNew() {
      let data = {
        customer: null,
        charging_site_title: null,
        emission_intensity: null,
        updated_at: "",
        id: 0,
      };
      this.current_row_index = this.battery_intensityDataList.length;
      this.data_modal = JSON.stringify(data);
      this.show_modal = true;
    },
    filterSearch(event) {
      this.search = event.search;
    },

    DeleteBatteryIntensities(user, index) {
      UserService.DeleteBatteryIntensities(user.id)
        .then(
          // eslint-disable-next-line no-unused-vars
          (response) => {
            this.battery_intensityDataList.splice(index, 1);
          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },

    deleteRow(event, index) {
      console.log(event, index);
      ElMessageBox.confirm("Are you sure to delete this?", "info", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "Confirm Delete",
      })
        .then(() => {
          this.DeleteBatteryIntensities(event, index);
          this.handleRefresh();
          // ElMessage({
          //   type: "success",
          //   message: "Delete completed",
          // });
        })
        .catch(() => {
          // ElMessage({
          //   type: "info",
          //   message: "Delete canceled",
          // });
        });
    },
  },
};
</script>

<style>
.el-table .warning-row {
  --el-table-tr-bg-color: var(--el-color-warning-light-8);
}
.el-table .error-row {
  --el-table-tr-bg-color: var(--el-color-error-light-8);
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.cell {
  text-align: center !important;
}

.starter-main .card-body ul {
  list-style-type: none !important;
}

.el-pager {
  -webkit-user-select: none !important;
  user-select: none !important;
  list-style: none !important;
  font-size: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  position: relative !important;
  top: 0 !important;
  right: 0 !important;
}

.el-upload-list {
  margin: 10px 0 0 !important;
  padding: 0 !important;
  list-style: none !important;
  position: relative !important;
}
</style>
